export function InfoBox({title, message, info}) {
    return(
        <div className="shadow-sm rounded border p-2 px-3 ">

            <div>
                <span className="info-box-title-border " style={{"fontSize": "0.95rem",'color': '#131313', fontWeight: "600"}}>{title}</span>
            </div>
            
            <p className="text-form-title mt-3" style={{"fontSize": "0.95rem", 'color': '#131313'}}>{message}</p>

            <div className="text-form-title text-center">
                {info}
            </div>

        </div>
    )
}
